import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

const noStyle = css`
  text-decoration: none;
  color: inherit;
`;

const StyledLink = styled(Link)`
  ${(props) => props.noStyle && noStyle};
`;

export default StyledLink;
